import {JsonProperty} from '@hyperloris/tyson';

export class FieldRecord<T> {

  @JsonProperty()
  id: string | undefined;

  @JsonProperty()
  text: string | undefined;

  @JsonProperty()
  value?: T;

  @JsonProperty()
  items?: FieldRecord<T>[];

  constructor(id?: string, text?: string, items?: FieldRecord<T>[]) {
    this.id = id;
    this.text = text;
    this.items = items;
  }

  static DEFAULT() {
    return new FieldRecord(null, null);
  }
}

